import { VesselBM } from '../../types/BusinessModel/Vessel/VesselBM';
import { Vessel } from 'src/types/ViewModel/Vessel/Vessel';
import { DryDockingFactory } from './DryDockingFactory';
import { MailRecipientFactory } from './MailRecipientFactory';
import { TankFactory } from './TankFactory';
import { VesselConfigurationV3Factory } from './VesselConfigurationV3Factory';

export class VesselFactory {
    private tankFactory = new TankFactory();
    private ddFactory = new DryDockingFactory();
    private mailRecFactory = new MailRecipientFactory();
    private vesselConfigurationV3Factory = new VesselConfigurationV3Factory();

    public getVessels(vessels: VesselBM[]) {
        if (vessels) {
            return vessels.map((o) => this.getVessel(o, true));
        }
        return [];
    }
    public getVessel(vessel: VesselBM, shallow: boolean): Vessel {
        const cargoTanks = this.tankFactory.getCargoTankList(vessel.tanks);
        cargoTanks.forEach((tank) => {
            tank.adjacentTanks.forEach((adjacentTank) => {
                adjacentTank.tank = cargoTanks.find((t) => t.tankId === adjacentTank.adjacentTankId);
            });
        });

        return new Vessel(
            vessel.imoNumber,
            vessel.vesselName ?? '???',
            vessel.technicalOperator ?? '???',
            vessel.maxBeaufortInCalmWeather,
            vessel.deadweightSummer,
            vessel.deadweightWinter,
            vessel.deadweightTropical,
            vessel.lightShipWeight,
            shallow ? null : this.vesselConfigurationV3Factory.create(vessel.vesselConfigurationV3),
            vessel.vesselEmail,
            vessel.suptEmail,
            vessel.opsEmail,
            vessel.orcaAolStartDate,
            vessel.orcaWebStartDate,
            shallow ? null : this.mailRecFactory.getMailRecipient(vessel.technicalSuperintendent),
            vessel.isActive,
            vessel.ownershipType,
            vessel.ownershipTypeId,
            vessel.ownershipTypeString,
            vessel.fleetId,
            vessel.vesselTradeTypeId,
            vessel.hasMaridis,
            vessel.yearBuilt,
            vessel.phoneNumber,
            vessel.hullType,
            vessel.vesselOwner,
            vessel.flag,
            vessel.callSign,
            vessel.cargoHeatingType,
            vessel.deliveredDate,
            vessel.targetSpeed,
            vessel.targetMainEngineConsumption,
            vessel.mainEngineConsumptionDeviationMargin,
            vessel.showSlip,
            vessel.showMainEngineSfoc,
            vessel.mainEngineRpmReductionFactor,
            vessel.reportsAolInId,
            vessel.vesselIsInImos,
            vessel.fleetPerformanceAlertResponsible,
            vessel.disponentOwnershipTypeId,
            vessel.financialOwnershipTypeId,
            shallow ? null : this.ddFactory.getDryDocking(vessel.nextDryDocking),
            vessel.isQuestionableCoatingCondition,
            vessel.questionableCoatingConditionComments,
            cargoTanks,
            shallow ? [] : this.tankFactory.getNonCargoTankList(vessel.tanks),
            vessel.isEquippedWithEgcs,
            vessel.hasOrcaWebSimpleMode,
            vessel.mrvVerifiedUntilDate,
            vessel.firstVoyageOrcaWebStowageViolations,
            vessel.firstVoyageOrcaWebStowageImosSync
        );
    }
}
